import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function availableHoursReducer(state = InitialState.availableHoursHistory, action) {
  switch (action.type) {
    case types.LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS:
      return action.availableHoursHistory;
    default:
      return state;
  }
}
